import { atom, selector, useRecoilState } from "recoil";
import { getRecoil } from "recoil-nexus";

export type orderDetailRealmType = {
  store_id: number;
  product_id: number;
  product_name: string;
  product_org_price: number;
  product_quantity: number;
  product_total_amount: number;
  option_price?: number;
  options: orderDetailOptionType[];
  // set_product: pickGroupListType[];
};

export type orderDetailOptionType = {
  option_id: number;
  option_type_id: number;
  option_type_name: string;
  option_name: string;
  option_price: number;
  option_input_max: number;
  option_input_min: number;
};

export const cartState = atom<orderDetailRealmType[]>({
  key: "cart",
  default: [],
});

export const getCartLength = (cart: orderDetailRealmType[]) => {
  let totalOrder = 0;
  for (let i = 0; i < cart.length; i++) {
    totalOrder += cart[i].product_quantity;
  }
  console.log("cart", cart);
  return totalOrder;
};
